import React from 'react'
import { StickyTable } from './containers/BlockTable'
import Table from './containers/Table'
import TerminalViewTable from './containers/TerminalViewTable'
import { ITable } from './types'

const defaultPageOptions = [10, 25, 50, 100, 150, 200]

export const stateReducer = (
  newState: any,
  action: any,
  prevState: any,
  options: any
) => {
  const {
    defaultPageSize,
    manualPagination,
    defaultPageIndex,
    defaultPageSizeOptions,
    defaultSelectedRowIds
  } = options
  if (action.type === 'init') {
    return {
      ...newState,
      pageSize: defaultPageSize || defaultPageSizeOptions[0],
      ...(defaultSelectedRowIds && Object.keys(defaultSelectedRowIds).length
        ? { selectedRowIds: defaultSelectedRowIds }
        : {}),
      ...(defaultPageIndex ? { pageIndex: defaultPageIndex } : {})
    }
  }
  if (['resetResize', 'resetPage'].includes(action.type)) {
    return {
      ...newState,
      pageIndex: defaultPageIndex ?? newState.pageIndex
    }
  }
  return newState
}

export const manipulateHooks = ({
  hooks,
  showRowSelect,
  expandable,
  sticky
}: any) => {
  if (showRowSelect || expandable) {
    hooks.visibleColumns.push((columns: any[]) => [
      {
        id: 'selection',
        width: 32,
        sticky: sticky ? 'left' : sticky,
        Header: ({ getToggleAllRowsSelectedProps }: any) => (
          <div style={{ textAlign: 'center' }}>
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({ row }: any) => (
          <div style={{ textAlign: 'center' }}>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        )
      },
      ...columns
    ])
  }
}

export const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }: any, ref) => {
    const defaultRef = React.useRef(null)
    const resolvedRef: any = ref || defaultRef
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])
    return (
      <input
        type="checkbox"
        ref={resolvedRef}
        {...rest}
        style={{ margin: 0, ...rest.style }}
      />
    )
  }
)

export function computeTWidth(headerGroups: any) {
  let windowW = window.innerWidth
  let colWid = 0
  headerGroups.map((group: any) => {
    group.headers.map((o: any) => {
      colWid += o.maxWidth > 2000 ? o.width ?? o.minWidth : o.maxWidth
    })
  })
  return windowW < colWid ? colWid : '100%'
}

function TableIndex(props: ITable) {
  var sticky: 'left' | 'right' | undefined = undefined
  props.columns.forEach((column: any) => {
    if ('sticky' in column) {
      sticky = column.sticky
      return false
    } else if (column.columns) {
      column.columns.forEach((column: any) => {
        if ('sticky' in column) {
          sticky = column.sticky
          return false
        }
      })
    }
  })

  if (sticky) {
    return <StickyTable {...props} sticky={sticky} />
  } else if (props.showTerminalView) {
    return <TerminalViewTable {...props} />
  } else {
    return <Table {...props} />
  }
}

export default TableIndex
